import { ThemeProvider, createTheme } from '@mui/material';
import React from 'react';
import '../../../index.css';

declare module '@mui/material/styles' {
  interface Palette {
    borderColor: string;
    labelColor: string;
    bgGray: {
      main: string;
      light: string;
    };
  }

  interface PaletteOptions {
    borderColor?: string;
    labelColor?: string;
    bgGray?: {
      main: string;
      light: string;
    };
  }
}

type ThemeProviderProps = {
  children: React.ReactNode;
};

const theme = createTheme({
  palette: {
    primary: {
      50: '#f8f3f8',
      main: '#6267AC',
      light: '#ECEFFE',
    },
    borderColor: '#EEEEEE',
    labelColor: 'var(--color-label)',
    bgGray: { main: '#F5F5F5', light: '#F9F9F9' },
    warning: {
      main: '#F4821F',
      light: '#FEF7F1',
    },
    error: {
      main: '#EF5251',
      light: '#ffabab',
    },
  },
  zIndex: {
    drawer: 999,
  },
  typography: {
    fontFamily: ['Mont-Regular', 'Mont-SemiBold'].join(','),
  },

  components: {
    MuiDivider: {
      defaultProps: {
        sx: {
          color: (theme) => theme.palette.borderColor,
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          borderRadius: '11px',
          backgroundColor: 'white',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#EEEEEE',
              borderRadius: '10px',
            },
            '&:hover fieldset': {
              borderColor: '#6267AC',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#6267AC',
            },
          },
        },
      },
    },
  },
});

theme.typography.h4 = {
  fontSize: '32px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '22px',
  },
};

theme.typography.h5 = {
  fontSize: '24px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '18px',
  },
};
theme.typography.body1 = {
  fontSize: '18px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '14px',
  },
};
theme.typography.body2 = {
  fontSize: '14px',
  [theme.breakpoints.down('sm')]: {
    fontSize: '12px',
  },
};

function SparkThemeProvider({ children }: ThemeProviderProps) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}

export default SparkThemeProvider;
